if (!customElements.get("header-section")) {
  customElements.define(
    "header-section",
    class HeaderSection extends HTMLElement {
      lastScrollPosition;
      isHeaderVisible;
      isAtTop;
      isScrollingDown;
      parentHeader;
      hamburgerButton;
      mobileMenu;
      megaMenuDropdowns;
      mobileMenuDropdowns;
      hamburgerOpenIcon;
      hamburgerCloseIcon;
      constructor() {
        super();
        this.lastScrollPosition = window.scrollY;
        this.isHeaderVisible = true;
        this.isAtTop = true;
        this.isScrollingDown = null;
        this.parentHeader = this.closest("#shopify-section-header");
        this.hamburgerButton = this.querySelector("[data-hamburger-button]");
        this.mobileMenu = this.querySelector("[data-menu-mobile]");
        this.megaMenuDropdowns = this.querySelectorAll("[data-mega-menu-dropdown-el]");
        this.mobileMenuDropdowns = this.querySelectorAll("[data-mobile-menu-dropdown-el]");
        this.hamburgerOpenIcon = this.querySelector("#mobile-burger-open-icon");
        this.hamburgerCloseIcon = this.querySelector("#mobile-burger-close-icon");
      }
      handleScroll() {
        const currentScrollPosition = window.scrollY;
        const isScrollingDown = currentScrollPosition > this.lastScrollPosition;
        const isAtTop = currentScrollPosition === 0;
        if (isScrollingDown !== this.isScrollingDown || isAtTop !== this.isAtTop) {
          this.isScrollingDown = isScrollingDown;
          this.isAtTop = isAtTop;
          if (isAtTop && this.parentHeader) {
            this.style.transform = "translateY(0)";
            this.isHeaderVisible = true;
          } else if (isScrollingDown && this.isHeaderVisible && this.parentHeader) {
            this.style.transform = "translateY(-130%)";
            this.isHeaderVisible = false;
          } else if (!isScrollingDown && !this.isHeaderVisible && this.parentHeader) {
            this.style.transform = "translateY(0)";
            this.isHeaderVisible = true;
          }
        }
        if (this.parentHeader) {
          const defaultTop = 0;
          const announcementBarClosed = !document.querySelector("[data-announcement-bar-root]")?.querySelector("[data-close-announcement]");
          const topOffset = announcementBarClosed && currentScrollPosition <= defaultTop ? -34 : !announcementBarClosed && currentScrollPosition <= defaultTop ? defaultTop : currentScrollPosition > defaultTop ? -34 : defaultTop;
          this.parentHeader.style.top = `${topOffset}px`;
        }
        this.lastScrollPosition = currentScrollPosition;
      }
      handleHamburgerClick() {
        if (this.mobileMenu && this.hamburgerButton) {
          this.hamburgerButton.addEventListener("click", () => {
            this.mobileMenu?.classList.toggle("hidden");
            this.hamburgerButton?.classList.toggle("is-active");
            this.hamburgerOpenIcon?.classList.toggle("hidden");
            this.hamburgerCloseIcon?.classList.toggle("hidden");
            document.querySelector("body")?.classList.toggle("overflow-hidden");
          });
        }
      }
      handleMobileMenuClick() {
        if (this.mobileMenu && this.mobileMenuDropdowns) {
          this.mobileMenuDropdowns.forEach((dropdown) => {
            dropdown.addEventListener("click", () => {
              const dropdownTriggerType = dropdown.dataset.mobileMenuDropdownEl;
              if (dropdownTriggerType === "open") {
                const elementSibling = dropdown.nextElementSibling;
                if (elementSibling && elementSibling.hasAttribute("data-mobile-menu-dropdown-panel-el")) {
                  elementSibling.classList.add("open-panel");
                  elementSibling.setAttribute("tabindex", "0");
                }
              } else if (dropdownTriggerType === "close") {
                const elementParent = dropdown.parentElement;
                if (elementParent && elementParent.hasAttribute("data-mobile-menu-dropdown-panel-el")) {
                  elementParent.classList.remove("open-panel");
                  elementParent.setAttribute("tabindex", "-1");
                }
              }
            });
          });
        }
      }
      handleMegaMenuHover() {
        if (this.megaMenuDropdowns) {
          this.megaMenuDropdowns.forEach((dropdown) => {
            dropdown.addEventListener("mouseenter", () => {
              document.body.classList.add("overflow-hidden");
            });
            dropdown.addEventListener("mouseleave", () => {
              document.body.classList.remove("overflow-hidden");
            });
          });
        }
      }
      init() {
        window.addEventListener("scroll", () => this.handleScroll());
        this.handleHamburgerClick();
        this.handleMobileMenuClick();
        this.handleMegaMenuHover();
      }
      // Lifecycle callback when the element is connected to the DOM
      connectedCallback() {
        this.init();
      }
    }
  );
}
